export const getFormattedObjectId = (name: string): string => {
  // Eliminem caràcters especials en les lletres ( accents, dieresis etc )
  name = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  // Eliminem qualsevol caràcter que no sigui lletra o número
  name = name.replace(/[^a-zA-Z0-9 ]/g, '')
  // Eliminem espais, per '_', i ho passem a mínuscula
  name = name.trim().replace(/\s/g, '_').toLowerCase()
  return name
}
